import React, { useContext, useRef, useEffect, useImperativeHandle } from 'react';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import useAriaAttributes from '@userzoomlibraries/toolkit-react-utils/use-aria-attributes';
import useDataAttributes from '@userzoomlibraries/toolkit-react-utils/use-data-attributes';
import { jsx } from 'react/jsx-runtime';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var NativeSelectContext = /*#__PURE__*/React.createContext();

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */

var useNativeSelect = function useNativeSelect() {
  return useContext(NativeSelectContext);
};

var _excluded = ["children", "disabled", "value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var NativeSelectOption = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      value = _ref.value,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var ariaAttributes = useAriaAttributes(otherProps);
  var dataAttributes = useDataAttributes(otherProps);

  var _useNativeSelect = useNativeSelect(),
      defaultValue = _useNativeSelect.defaultValue;

  var nativeSelectOptionRef = useRef();
  useEffect(function () {
    // We need to add the selected attribute manually to avoid console warnings
    if (nativeSelectOptionRef.current) {
      if (defaultValue === value) {
        nativeSelectOptionRef.current.setAttribute('selected', '');
      } else {
        nativeSelectOptionRef.current.removeAttribute('selected');
      }
    }
  }, [defaultValue, value]);
  useImperativeHandle(ref, function () {
    return nativeSelectOptionRef.current;
  });
  return /*#__PURE__*/jsx("option", _objectSpread(_objectSpread(_objectSpread({
    ref: nativeSelectOptionRef,
    className: "gz-native-select__option",
    disabled: disabled,
    value: value // eslint-disable-next-line react/jsx-props-no-spreading

  }, ariaAttributes), dataAttributes), {}, {
    children: children
  }));
});
NativeSelectOption.COMPONENT_ID = 'Gearz.NativeSelect.Option';
NativeSelectOption.displayName = NativeSelectOption.COMPONENT_ID;
NativeSelectOption.propTypes = {
  children: PropTypes.stringWithDescription('Content of the option.'),
  disabled: PropTypes.boolWithDescription('Flag to make the option disable.'),
  value: PropTypes.oneOfTypeWithDescription([PropTypes.number, PropTypes.string], 'Value of the option.').isRequired
};
NativeSelectOption.defaultProps = {
  children: null,
  disabled: false
};

export { NativeSelectOption as N, NativeSelectContext as a };
